//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// if (process.env.NODE_ENV === 'component') {
//   require('bh-mint-ui2/packages/font/style.css');
// }

/**
 * @name Button
 * @tagName mt-button
 * @desc 按钮
 * @wrapClassName mint-button
 * @display inline
 * @noteType component
 * @html
 * <mt-button type="primary">{{text}}</mt-button>
 */
export default {
  name: 'mt-button',

  methods: {
    handleClick(evt) {
      this.$emit('click', evt);
    }
  },

    /**
     * @noteType prop
     * @field text
     * @desc 文字
     * @type input
     * @value 按钮
     */
  props: {
      /**
       * @noteType prop
       * @field icon
       * @desc 图标
       * @type select
       * @option
       [
       {
         "text": "空",
         "value": ""
       },
       {
         "text": "返回",
         "value": "back"
       },
       {
         "text": "更多",
         "value": "more"
       }
       ]
       */
    icon: String,
    iconSize:String,
    iconColor:String,
    disabled: Boolean,
    nativeType: String,
    plain: Boolean,
      /**
       * @noteType prop
       * @field type
       * @desc 样式
       * @type select
       * @value primary
       * @option
       [
       {
         "text": "default",
         "value": "default"
       },
       {
         "text": "primary",
         "value": "primary"
       },
       {
         "text": "danger",
         "value": "danger"
       },
       {
         "text": "warning",
         "value": "warning"
       }
       ]
       */
    type: {
      type: String,
      default: 'default',
      validator(value) {
        return [
          'default',
          'danger',
          'warning',
          'primary'
        ].indexOf(value) > -1;
      }
    },
      /**
       * @noteType prop
       * @field size
       * @desc 大小
       * @type select
       * @value normal
       * @option
       [
       {
         "text": "normal",
         "value": "normal"
       },
       {
         "text": "small",
         "value": "small"
       },
       {
         "text": "large",
         "value": "large"
       }
       ]
       */
    size: {
      type: String,
      default: 'normal',
      validator(value) {
        return [
          'small',
          'normal',
          'large'
        ].indexOf(value) > -1;
      }
    }
  }
};

/**
 * @noteType external
 * @content
 {
   "edit": [
   {
     "selector": "label",
     "forAttribute": "text"
   }
   ],
   "mock": {
            "text": "按钮"
          },
   "textField": {
            "field": "text",
            "className": "mint-button-text"
          },
   "bindField":"text"
 }
 */



// WEBPACK FOOTER //
// ./packages/button/src/button.vue